export const getters = {
    list: state => state.list,
    inventory: state => state.inventory,
    columns: state => state.columns,
    model: state => state.model,
    filter: state => state.filter,
    chart: state => state.chart,
    pagination: state => state.pagination,
    sort: state => state.sort,
    rules: state => state.rules,
};